import { render, staticRenderFns } from "./SectionIntroductionTest.vue?vue&type=template&id=2c89bea5"
import script from "./SectionIntroductionTest.vue?vue&type=script&lang=js"
export * from "./SectionIntroductionTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports